import React from 'react';
import QualityUpdate from './QualityUpdate';

export default function QualityUpdatesList({ updates }) {
  return updates.map(update => <QualityUpdate key={`${update.type}$${update.message}`} data={update} />);
}